<section
  class="mx-auto flex w-full max-w-360 flex-1 flex-col p-6 2xl:px-0"
  aria-labelledby="qoe-page-heading"
>
  <!-- Page Header -->
  <div
    class="flex w-full flex-wrap items-start justify-between gap-4 pb-4 md:flex-nowrap lg:gap-12"
  >
    <div class="min-w-0">
      <a
        routerLink="/analytics/dashboard"
        class="mb-1 inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-widest text-black"
        aria-label="Back to IQ Analytics"
      >
        IQ Analytics
      </a>
      <h1
        id="qoe-page-heading"
        class="m-0 flex items-center gap-2 font-montserrat text-3xl font-bold leading-tight text-gray-900 [text-wrap:auto]"
      >
        Quality of Experience
      </h1>
      <p class="mt-1 text-sm text-gray-400">
        Carrier quality trends and time-of-day experience for the selected time frame.
      </p>
    </div>

    <div
      class="flex flex-wrap items-center justify-center gap-2"
      role="toolbar"
      aria-label="QoE controls"
    >
      @if (canShowSampleDataToggle()) {
        <app-toggle
          [(ngModel)]="showMockData"
          (ngModelChange)="toggleMockData($event)"
          label="Sample Data"
          [ariaLabel]="showMockData ? 'Currently showing sample data. Switch to real data.' : 'Currently showing real data. Switch to sample data.'"
          size="md"
          color="primary"
        >
        </app-toggle>
      }
      <app-analytics-time-selector
        (selectedOptionChange)="onChildSelectionChange($event)"
      />
    </div>
  </div>

  <!-- Charts surface -->
  <div class="mt-2">
    <div class="w-full">
      @if (!isNoContent && !loading) {
        <div
          class="grid w-full min-w-0 grid-cols-1 gap-[1px] overflow-hidden bg-gray-150 shadow-sm md:grid-cols-5"
          aria-label="Quality of Experience charts"
        >
          <div class="flex min-w-0 flex-col bg-white p-4 md:col-span-3 lg:p-5">
            <h2
              class="m-0 mb-0 flex items-center gap-1.5 font-montserrat text-base font-semibold uppercase tracking-wider text-gray-900"
            >
              <span class="material-icons-outlined text-[16px]" aria-hidden="true"
                >schedule</span
              >
              QoE By Time of Day
            </h2>
            <app-analytics-widget
              [isNoContent]="isNoContent"
              [loading]="loading"
              class="h-full w-full"
            >
              <qoe-by-time-chart
                [data]="timeOfDayBreakdownData"
                [categories]="timeOfDayBreakdownLabels"
              />
            </app-analytics-widget>
          </div>
          <div class="flex min-w-0 flex-col bg-white p-4 md:col-span-2 lg:p-5">
            <h2
              class="m-0 mb-0 flex items-center gap-1.5 font-montserrat text-base font-semibold uppercase tracking-wider text-gray-900"
            >
              <span class="material-icons-outlined text-[16px]" aria-hidden="true"
                >pie_chart</span
              >
              {{ timeOfDayBreakdownTitleProvider }}
            </h2>
            <app-analytics-widget
              [isNoContent]="isNoContent"
              [loading]="loading"
              class="h-full w-full"
            >
              <app-analytics-apex-chart-pie
                [series]="carrierData"
                [labels]="carrierLabels"
                [title]="''"
                [manualColors]="carrierColors"
                [strokeColor]="'#ffffff'"
              />
            </app-analytics-widget>
          </div>
        </div>
      } @else {
        <div
          class="no-charts-container flex h-72 flex-col items-center justify-center"
          role="status"
          aria-live="polite"
          aria-label="No QoE problems found in this time range"
        >
          <div
            class="no-charts-icon bg-happy-face h-64 w-64 bg-center bg-no-repeat"
            aria-hidden="true"
          ></div>
          <p class="no-charts-text mt-4 mb-8 text-2xl text-gray-700">
            No QoE problems found in this time range
          </p>
        </div>
      }
    </div>
  </div>

  <div class="mt-2 w-full">
    @if ((qoeRawDeviceEvents$ | async)?.devices.length && !isLoadingData) {
      <app-qoe-data-table
        [deviceEvents]="(qoeRawDeviceEvents$ | async)?.devices"
        [isLoading]="isLoadingData"
        [isNoContent]="isNoContent"
      ></app-qoe-data-table>
    } @else {
      <div
        class="flex flex-col items-center justify-center rounded-md border border-gray-150 bg-white p-12 shadow-sm"
        role="status"
        aria-live="polite"
      >
        <mat-icon
          fontSet="material-icons-outlined"
          class="mb-2 !text-5xl text-gray-300"
          aria-hidden="true"
          >devices</mat-icon
        >
        <h2 class="font-montserrat text-lg font-semibold text-gray-700">
          No Devices Found
        </h2>
        <p class="mt-1 max-w-sm text-center font-lato text-sm text-gray-500">
          No devices reported quality of experience events for the selected time
          range.
        </p>
      </div>
    }
  </div>
</section>
